import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { StaticImageData } from 'next/image';

interface Props {
  name?: string;
  part?: string;
  productImage: StaticImageData;
  productImageHover: StaticImageData;
}

export const ProductSlides: React.FC<Props> = props => {
  return (
    <Stack>
      <Box
        sx={{
          width: '100%',
          backgroundImage: 'url(' + props.productImage.src + ')',
          minHeight: '300px',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          transition: 'background-image 0.5s ease-in-out',
          '&: hover': {
            backgroundImage: 'url(' + props.productImageHover.src + ')',
          },
        }}
      ></Box>
      <Box>
        <Typography fontWeight={700}>{props.name}</Typography>
      </Box>
      <Box>
        <Typography sx={{ color: 'secondary.light' }}>{props.part}</Typography>
      </Box>
    </Stack>
  );
};
